import { getRouteApi } from '@tanstack/react-router';
import { signInWithCustomToken, signOut } from 'firebase/auth';
import { auth, useAuth } from '@discovr/common';
import { members } from '@discovr/api';
import { InviteAcceptPage } from '@discovr/ui';

const activateRoute = getRouteApi('/activate');

/**
 * Brand-owner activation — first-time set-password via the 7-day single-use
 * token emailed on waitlist approval. Reuses the shared InviteAcceptPage in
 * 'activation' mode (no name fields) — the backend now returns a Firebase
 * custom token from set-password, same as the invite flow, so the owner is
 * signed in immediately instead of being bounced through /login.
 */
export default function ActivatePage() {
  const { token } = activateRoute.useSearch();
  const { user, loading: authLoading } = useAuth();
  return (
    <InviteAcceptPage
      token={token}
      variant="activation"
      verifyFn={(token) => members.verifyActivation(token)}
      acceptFn={(body) => members.setActivationPassword({ token: body.token, password: body.password })}
      orgNameKey="brand_name"
      successRedirect="/"
      currentUserEmail={authLoading ? undefined : (user?.email ?? null)}
      onSignOutCurrentUser={() => signOut(auth)}
      signInWithToken={async (token) => {
        await signOut(auth).catch(() => {});
        await signInWithCustomToken(auth, token);
      }}
    />
  );
}
